import styled from '@emotion/styled';

import theme from 'styles/theme';

export const FiltersBarContainer = styled.div`
  &::after {
    content: '';
    display: block;
    border-top: 1px dashed ${theme.colors.lightGray};
    margin: 0 24px 16px;
  }

  @media (max-width: 768px) {
    &::after {
      margin: 0 16px 12px;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 16px;

  @media (min-width: 769px) {
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(160px, 1.15fr);
    gap: 20px;
    padding: 20px 24px 16px;
  }
`;

export const AmountPrefix = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${theme.colors.mediumGray};
`;

export const AmountFieldWrap = styled.div`
  max-width: 200px;

  @media (max-width: 768px) {
    max-width: none;
  }
`;
